import { ExperienceType } from '@/generated/graphql';
import { useSearchParams } from 'next/navigation';
import { EXPLORE_FILTER_TYPE } from './use-experience-filter';

const useType = () => {
  const searchParams = useSearchParams();
  const type = searchParams?.get(EXPLORE_FILTER_TYPE);
  return type as undefined | ExperienceType;
};

export default useType;
